import { types } from '../../types';

const setGetCreditLimitsAction = (payload) => {
  return {
    type: types.credit.SET_LIST_CREDIT,
    payload,
  }
}

const setGetListGroupsAction = (payload) => {
  return {
    type: types.credit.SET_LIST_GROUPS,
    payload,
  }
}

const setGetCreditLiveAction = (payload) => {
  return {
    type: types.credit.SET_CREDIT_LIVE,
    payload,
  }
}

const setGetCreditHistoryAction = (payload) => {
  return {
    type: types.credit.SET_LIST_CREDIT_HISTORY_MOBILE,
    payload,
  }
}

export {
  setGetCreditLimitsAction as SetGetCreditLimitsAction,
  setGetListGroupsAction as SetGetListGroupsAction,
  setGetCreditLiveAction as SetGetCreditLiveAction,
  setGetCreditHistoryAction as SetGetCreditHistoryAction
}
